import React, { useState } from "react"
import {
	Grid,
	TextField,
	Chip
} from "@material-ui/core"
import Autocomplete from "@material-ui/lab/Autocomplete"

import { renderComponent } from "@/utils/node"
import { formatAssignAttendanceOptions, getCurrentAssignAttendanceOption } from "@/utils/chatBot"

import { ActionDialog } from "@/components"

import useStyles from "@/pages/Admin/ChatBot/ChatBotConstructor/Blocks/AssignAttendanceBlock/AttendanceEditor/styles"

import {
	ChatBotFlowBlockContent
} from "@/protocols/chatBot"
import { ConstructionResources } from "@/protocols/chatBotConstructor"

type AttendanceEditorProps = {
	onSave: (chatBotFlowBlockContent: ChatBotFlowBlockContent) => void
	constructionResources: ConstructionResources
	chatBotFlowBlockContent: ChatBotFlowBlockContent
}

type AttendanceEditorType = {
	open: (props: AttendanceEditorProps) => void
}

const AttendanceEditor: AttendanceEditorType & React.FC<AttendanceEditorProps> = (props) => {
	const {
		onSave,
		constructionResources,
		chatBotFlowBlockContent
	} = props

	const classes = useStyles()

	const [opened, setOpened] = useState(true)

	const [blockContent, setBlockContent] = useState<ChatBotFlowBlockContent>(chatBotFlowBlockContent)

	const handleClose = () => {
		setOpened(false)
	}

	const handleSave = async () => {
		onSave(blockContent)

		handleClose()
	}

	const handleChangeContent = (content: Partial<ChatBotFlowBlockContent>) => {
		setBlockContent(lastState => ({
			...lastState,
			...content
		}))
	}

	const allAssignOptions = formatAssignAttendanceOptions(constructionResources)

	return (
		<ActionDialog
			title="DIRECIONAMENTO PARA EQUIPE OU ATENDENTE"
			onSave={handleSave}
			saveText="SALVAR"
			onClose={handleClose}
			openDialog={opened}
			fullWidth
			maxWidth="md"
		>
			<Grid
				container
				spacing={2}
			>
				<Grid
					item
					xs={12}
				>
					<Autocomplete
						defaultValue={getCurrentAssignAttendanceOption(constructionResources, chatBotFlowBlockContent)}
						options={allAssignOptions}
						getOptionSelected={(option, value) => option.slug === value.slug}
						getOptionLabel={(option) => option.name}
						groupBy={option => option.title}
						fullWidth
						filterSelectedOptions
						onChange={(_, queue) => {
							if (queue) {
								handleChangeContent({
									attendanceAssignmentData: {
										assignedTeamId: queue.assignedTeamId,
										assignedUserId: queue.assignedUserId,
										assignmentQueueType: queue.assignmentQueueType
									}
								})
							}
						}}
						renderInput={(params) => {
							return (
								<TextField
									className={classes.filterInput}
									variant="outlined"
									placeholder="Selecione uma equipe ou um atendente"
									{...({
										...params,
										InputProps: {
											...params.InputProps
										}
									})}
								/>
							)
						}}
						renderTags={(value, getTagProps) => {
							return value.map((attendant, index) => (
								<Chip
									key={index}
									label={attendant.name}
									size="small"
									{...getTagProps({ index })}
								/>
							))
						}
						}
						size="small"
					/>
				</Grid>
			</Grid>
		</ActionDialog>
	)
}

AttendanceEditor.open = (props: AttendanceEditorProps) => {
	renderComponent(
		"attendance-editor",
		<AttendanceEditor
			{...props}
		/>
	)
}

export default AttendanceEditor
